module.exports = __webpack_public_path__ + "2d2ee15b14a82f6024cadadb7eedc249.png";